import { SavePlaybookResultMutationVariables } from "@/graphql/generated/graphql";
import { SavePlaybookResult } from "@/graphql/mutations/SavePlaybookResult";
import { getErrorMessageFromBackendError } from "@/helpers/graphql/graphql.helpers";
import { useGraphMutation, useToast } from "@dashboard/library";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function useSavePlaybookResult() {
  const { t } = useTranslation();
  const { show } = useToast();
  const [mutate, { loading }] = useGraphMutation(SavePlaybookResult);

  const savePlaybookResult = useCallback(
    async (variables: SavePlaybookResultMutationVariables) => {
      const { exceptions, error } = await mutate({
        refetchQueries: ["GetPlaybookResults"],
        variables,
      });

      if (error) {
        show({
          message: t("error.generic.title"),
          variant: "critical",
        });
        return t(error);
      }

      const exception =
        exceptions?.GenericException ||
        exceptions?.UserInputException ||
        exceptions?.PlaybookException ||
        exceptions?.InsufficientLicenseException;

      if (exception) {
        const errorMessage = getErrorMessageFromBackendError(exception);
        show({
          message: errorMessage,
          variant: "critical",
        });
        return errorMessage;
      }

      show({
        message: t("playbook.playbook_updated"),
        variant: "success",
      });
      return undefined;
    },
    [t]
  );

  return {
    savePlaybookResult,
    loading,
  };
}
